import { AppState } from 'state/store';
import { QueryState } from 'state/query/QueryReducer';

export const selectCurrentQuery = ({ query }: AppState): QueryState => {
   return query;
};
